import { useEffect } from 'react';

import { Action, ActionsList } from 'components';
import { useFormContext } from 'libs/form/useFormContext';
import { useTranslation } from 'libs/i18n';
import { Icon } from 'libs/ui/Icon';

export const AccountingSystemActions = () => {
  const { t } = useTranslation();
  const { readOnly, setReadOnly, resetForm } = useFormContext();

  useEffect(() => {
    if (readOnly) {
      resetForm();
    }
  }, [readOnly, resetForm]);

  if (!readOnly) {
    return null;
  }

  return (
    <ActionsList>
      <Action tooltip={t('common.edit')} onClick={() => setReadOnly(false)}>
        <Icon.Edit size={16} />
      </Action>
    </ActionsList>
  );
};
